const Spinner = (props) => {
  
  return <div className='pos-center'><div style={{display: props.isLoading ? 'block' : 'none' }} className="loader"></div></div>;
};

export default Spinner;
